import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [effectiveStatus, setEffectiveStatus] = useState("explore");
  const [hasActiveAccess, setHasActiveAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const r = await api.get("/me");
      setUser(r.data.user);
      setEffectiveStatus(r.data.effectiveStatus);
      setHasActiveAccess(r.data.hasActiveAccess);
    } catch {
      setUser(null); setEffectiveStatus("explore"); setHasActiveAccess(false);
    }
  };

  // Pulls fresh state from Stripe — call after returning from checkout
  const refreshFromStripe = async () => {
    try {
      const r = await api.post("/me/refresh");
      setUser(r.data.user);
      setEffectiveStatus(r.data.effectiveStatus);
      setHasActiveAccess(r.data.hasActiveAccess);
    } catch {}
  };

  useEffect(() => { (async () => { await refresh(); setLoading(false); })(); }, []);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(null); setEffectiveStatus("explore"); setHasActiveAccess(false);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, effectiveStatus, hasActiveAccess, loading, refresh, refreshFromStripe, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}
